import R from 'ramda'

// FILEABLE NAME
const ascByFileableName = R.ascend(R.path(['fileable', 'name']))
const descByFileableName = R.descend(R.path(['fileable', 'name']))

// POSITIONS
const ascByPosition = R.ascend(R.prop('position'))
const ascByFileablePosition = R.ascend(R.path(['fileable', 'position']))

// SHARED

// Sort first by author name, then name of folder
const ascByAuthor = [R.ascend(R.prop('authorName')), R.ascend(R.prop('name'))]

// Sort first by most recent date, then by name of folder
const descByDate = [R.descend(R.prop('sharedAt')), R.ascend(R.prop('name'))]

export default {
  ascByFileableName,
  descByFileableName,
  ascByPosition,
  ascByFileablePosition,
  ascByAuthor,
  descByDate,
}
